<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body ">
                        <div class="row d-flex align-items-center">
                            <div class="col-lg-auto">
                                <h5 class="card-title m-0">
                                    <i class="bx bx-spreadsheet me-1 text-primary"></i>Finance Reports
                                </h5>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-auto">
                                <div class="input-group">
                                  <span class="input-group-text bg-primary" id="search" ngbTooltip="Filter by From date." placement="top"
                                    container="body">
                                    <i class="bx bx-calendar-week"></i>
                                  </span>
                                  <input type="date" class="form-control border-start-0" id="search" placeholder="From date..." autocomplete="off"
                                    [(ngModel)]="startDate">
                                </div>
                              </div>
                              <div class="col-sm-12 col-md-3 col-lg-auto ps-1">
                                <div class="input-group">
                                  <span class="input-group-text bg-primary" id="search" ngbTooltip="Filter by To date." placement="top"
                                    container="body">
                                    <i class="bx bx-calendar-week"></i>
                                  </span>
                                  <input type="date" class="form-control border-start-0" id="search" placeholder="To date..." autocomplete="off"
                                    [(ngModel)]="endDate" [min]="startDate">
                                </div>
                              </div>
                            <div class="col-sm-12 col-md-3 col-lg-auto ps-1">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary" id="types" ngbTooltip="Filter by Account Type." container="body">
                                        <i class='bx bxs-report'></i>
                                    </span> 
                                    <ng-select class="rcx-ng-select ng-nav" bindLabel="name" id="type" [(ngModel)]="type"
                                        placeholder="Select Account Type" [clearable]="false" [searchable]="true">
                                        <ng-option *ngFor="let type of types" [value]="type">{{type}}</ng-option>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-1 me-auto ps-1">
                                <div class="input-group">
                                    <button type="button" ngbTooltip="Fetch Records." placement="top" container="body" style="font-size: 18px;"
                                        class=" btn btn-secondary btn-sm " (click)="getFinanceReport()">
                                        <i class="bx bx-search-alt-2 ri-lg align-middle me-0"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <table class="table" id="table">
                            <thead id="table-thead">
                                <tr class="bg-light">
                                    <th scope="col" width="70">#</th>
                                    <th scope="col" width="300">Name</th>
                                    <th scope="col" width="300">Payment Date</th>
                                    <th scope="col" width="300">Type</th>
                                    <th scope="col" width="300">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let finance of financeReports | search : 'name' : searchKeyword; let i=index">
                                    <td>{{i+1}}.</td>
                                    <td>{{finance.name}}</td>
                                    <td>{{finance.paymentDate | date:'MMM dd, yyyy'}}</td>
                                    <td>{{finance.type}}</td>
                                    <td>{{finance.amount}}</td>
                                </tr>
                                <tr class="no-data">
                                    <ng-container *ngIf="isLoading; else noDataTemplate">
                                        <td colspan="6">Fetching data, please wait...</td>
                                    </ng-container>
                                    <ng-template #noDataTemplate>
                                        <ng-container
                                            *ngIf="financeReports && financeReports.length < 1; else noSearchResults">
                                            <td colspan="6">No finance reports were found.</td>
                                        </ng-container>
                                        <ng-template #noSearchResults>
                                            <td colspan="6"
                                                *ngIf="searchKeyword && (financeReports | search : 'name' : searchKeyword).length == 0">
                                                No finance reports were found for the search results.
                                            </td>
                                        </ng-template>
                                    </ng-template>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>